import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { ClerkProvider } from '@clerk/clerk-react'
import { AuthProvider_M1_1 } from '@/contexts/AuthProvider'
import { isDemoMode_M12_4, getClerkPublishableKey_M12_1 } from '@/lib/constants'
import { ErrorBoundary } from '@/components/ErrorBoundary'
import { routeTree } from './routeTree.gen'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 2,
      retry: 1,
    },
  },
})

const router = createRouter({ routeTree })

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

function AppInner_M10_31() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider_M1_1>
        <RouterProvider router={router} />
      </AuthProvider_M1_1>
    </QueryClientProvider>
  )
}

export default function App() {
  const isDemo = isDemoMode_M12_4()

  if (isDemo) {
    return (
      <ErrorBoundary>
        <AppInner_M10_31 />
      </ErrorBoundary>
    )
  }

  let clerkKey: string
  try {
    clerkKey = getClerkPublishableKey_M12_1()
  } catch {
    return (
      <ErrorBoundary>
        <AppInner_M10_31 />
      </ErrorBoundary>
    )
  }

  return (
    <ErrorBoundary>
      <ClerkProvider publishableKey={clerkKey}>
        <AppInner_M10_31 />
      </ClerkProvider>
    </ErrorBoundary>
  )
}
